import { DonationApiClient } from '@fourthwall/services/dist/DonationApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDonationQuery = createQueryHook(DonationApiClient.getDonation, {
  queryKey: ['donation'],
})
